import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {BaseInput} from 'ionic-angular/util/base-input';
import {ValueAccessor} from '../../../interfaces/value-accessor';
import {CustomFormControlValueAccessor} from '../../../mixin/form/custom-form-control-value-accessor';

/**
 * Abstract implementation for inputs. Has a value.
 * @class AbstractInput
 * @extends CustomFormControlValueAccessor
 * @implements {ValueAccessor}
 * @abstract
 */
@Component({
  selector: 'advtech-abstract-input',
  templateUrl: './abstract.input.html',
})
export class AbstractInput extends CustomFormControlValueAccessor implements ValueAccessor {
  /**
   * Value for the input
   * @type {any}
   */
  @Input()
  value: any;

  /**
   * Value for the form name
   * @type {any}
   */
  @Input()
  formName: any;

  /**
   * Used to conditionally display the error div
   * @type {boolean}
   */
  showErrorDiv: boolean = false;

  /**
   * The error text to be displayed
   * @type {string}
   */
  errorText: string;

  /**
   * Output for the onInput event
   * @type {EventEmitter}
   */
  @Output()
  onInput: EventEmitter<object> = new EventEmitter();

  /**
   * Input in the template
   */
  @ViewChild('input')
  input: BaseInput<any>;

  /**
   * Gets the form name
   * @returns {any}
   */
  getFormName(): any {
    return this.formName;
  }

  /**
   * Sets the form name
   * @param {any} value the form name
   * @returns {AbstractInput}
   */
  setFormName(value: any): AbstractInput {
    this.formName = value;

    return this;
  }

  /**
   * Gets the value
   * @returns {any}
   */
  getValue(): any {
    return this.input.value;
  }

  /**
   * sets the value
   * @param {any} value the value for the input
   * @returns {AbstractInput}
   */
  setValue(value): this {
    this.input && this.input.setValue(value);

    return this;
  }

  /**
   * Emits the onInput event
   * @param {any} event change object
   * @returns {void}
   */
  hChange(event: any): void {
    this.onInput.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/inputs/abstract/abstract.input.ts